import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import '../App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../Login/Login.css';
import Footer from '../Footer/Footer'; // Correct import for Footer

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post('https://zingapi.beeinnovations.com/boxoffice_app/zingadminlogin.php', {
        username: username,
        password: password,
      });

      console.log('API Response:', response);

      if (response.status === 200) {
        localStorage.setItem('Zing_login', true);
        navigate('/Dashboard');
      } else {
        setError(response.data.message || 'Invalid username or password');
      }
    } catch (error) {
      console.error('Login error:', error);
      setError('An error occurred. Please try again.');
    }
  };

  return (
    <div>
      <div className="wrapper">
        <center>
          <h5 className='sai_responsive_name'>BI Reporting System</h5>
        </center>
        <form className="form-signin" onSubmit={handleLogin}>
          <input
            type="text"
            className="form-control"
            name="username"
            placeholder="User Name"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
            autoFocus
          />
          <input
            type="password"
            className="form-control mt-2"
            name="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          {error && <div className="alert alert-danger">{error}</div>}
          <button className="btn btn-lg btn-block" type="submit">
            Login
          </button>
        </form>
        <center className='mt-2'>
          <h6>Forgot Password ?</h6>
        </center>
      </div>
      <div className='for_footer'>
      <Footer />
      </div>
      
    </div>
  );
};

export default Login;
